import { graphqlClient } from "@/utils/graphql";
import { FILE_CATEGORIES_QUERY } from "@/models/queries/FileCategoriesQuery";
import { FileCategories } from "@/models/queries/types/FileCategories";

export const fileStore = {
  namespaced: true,
  state: {
    fileCategories: []
  },
  mutations: {
    FETCH_CATEGORIES(state, categories) {
      state.fileCategories = categories;
    }
  },
  actions: {
    async loadFileCategories({ commit }) {
      const result = await graphqlClient.query<FileCategories>({
        query: FILE_CATEGORIES_QUERY
      });
      commit("FETCH_CATEGORIES", result.data.fileCategories);
    }
  }
};
